var localForage = require('localforage');
var _ = require('lodash');

export default {
    install: function (Vue, opts) {
        let customers = {};
        customers.loading = false;      // caricamento dell'oggetto
        customers.data = [];            // l'elenco degli elementi
        customers.dataOff = [];         // l'elenco degli elementi offline
        customers.page = 1;             // pagina corrente
        customers.isEndList = false;    // indica se sono alla fine della lista
        customers.isFirstList = true;   // indica se sono all'inizio della lista
        Vue.mixin({
            mounted() {
                /**
                 * Ritorna un singolo
                 * @param id
                 * @returns {Promise<unknown>}
                 */
                customers.getSingle = (id) => {
                    return new Promise((resolve, reject) => {
                        customers.loading = true;
                        let params = {};
                        this.api.get(`/customers/${id}`, params, true)
                            .then((result) => {
                                if (result && result.success) {
                                    resolve(result.data);
                                }
                                reject(null);
                            })
                            .catch(() => {
                                reject(null);
                            })
                            .finally(() => {
                                customers.loading = false;
                            });
                    });
                };
                /**
                 * Salvataggio
                 * @param data
                 * @param id
                 * @returns {Promise<unknown>}
                 */
                customers.save = (data, id) => {
                    return new Promise((resolve, reject) => {
                        id = (id.toString().toLowerCase().trim() === 'new') ? null : id;
                        let call = null;
                        if (id == null) {
                            call = this.api.post(`/customers`, data, false);
                        } else {
                            call = this.api.put(`/customers/${id}`, data, false);
                        }
                        call.then((result) => {
                            if (result && result.success) {
                                resolve(true);
                            }
                            reject(null);
                        })
                            .catch((error) => {
                                reject(error);
                            });
                    });
                };
                customers.merge = (form, id, list) => {
                    return new Promise((resolve, reject) => {
                        let data = {
                            'form': form,
                            'id': id,
                            'list': list
                        };
                        this.api.post(`/customers/merge`, data, false)
                            .then((result) => {
                                if (result && result.success) {
                                    resolve(true);
                                }
                                reject(null);
                            })
                            .catch((error) => {
                                reject(error);
                            });
                    });
                };
                customers.delete = (id) => {
                    return new Promise((resolve, reject) => {
                        this.api.delete(`/customers/${id}`, false).then((result) => {
                            if (result && result.success) {
                                resolve(true);
                            }
                            reject(null);
                        })
                            .catch((error) => {
                                reject(error);
                            });
                    });
                }

                /**
                 * Lista degli utenti
                 */
                customers.getList = (searchText) => {
                    searchText = searchText || '';
                    customers.loading = true;
                    let params = {
                        page: customers.page,
                        search: searchText,
                        sort: 'agency'
                    };
                    this.api.get('/customers', params, true)
                        .then((result) => {
                            customers.data = [];
                            for (var key in result.data) {
                                customers[key] = result.data[key];
                            }
                            customers.isFirstList = true;
                            customers.isEndList = false;
                            if (customers.page !== 1) {
                                customers.isFirstList = false;
                                customers.isEndList = false;
                            }
                            if (customers.page == customers.pages) {
                                customers.isEndList = true;
                                customers.isFirstList = false;
                            }
                        })
                        .finally(() => {
                            customers.loading = false;
                        });
                };
                /**
                 * Prende i dati della pagina successiva
                 */
                customers.nextPage = () => {
                    if (customers.page < customers.pages) {
                        customers.page = customers.page + 1;
                        customers.getList();
                    }
                };
                /**
                 * Prende i dati della pagina precendente
                 */
                customers.prevPage = () => {
                    if (customers.page > 1) {
                        customers.page = customers.page - 1;
                        customers.getList();
                    }
                };
                /**
                 * Prende i dati della prima pagina
                 */
                customers.firstPage = () => {
                    customers.page = 1;
                    customers.getList();
                };
                /**
                 * Prende i dati dell'ultima pagina
                 */
                customers.lastPage = () => {
                    customers.page = customers.pages;
                    customers.getList();
                };
                /**
                 * Prende i dati di una pagina prefissata
                 * @param page
                 */
                customers.goPage = (page) => {
                    if (page > 0 && page <= customers.pages) {
                        customers.page = page;
                        customers.getList();
                    }
                };

                let offlineMethods = {};
                offlineMethods.buildOfflineData = (page, pageSize, searchText) => {
                    let offset = (page - 1) * pageSize;

                    searchText = searchText || "";
                    searchText = searchText.trim();
                    searchText = searchText.toLowerCase();
                    let data = [];
                    if (searchText != "") {
                        data = customers.dataOff.filter((item) => {
                            let checkAgency = (item.agency.replace(/\./gi, "").toLowerCase().trim().indexOf(searchText) >= 0) ? true : false;
                            let checkFirstName = (item.first_name.replace(/\./gi, "").toLowerCase().trim().indexOf(searchText) >= 0) ? true : false;
                            let checkLastName = (item.last_name.replace(/\./gi, "").toLowerCase().trim().indexOf(searchText) >= 0) ? true : false;
                            let checkVatNumber = (item.vat_number.replace(/\./gi, "").toLowerCase().trim().indexOf(searchText) >= 0) ? true : false;
                            // console.log(`Cerca: ${searchText} (${item.agency.replace(/\./gi, "").toLowerCase().trim()}) == ${checkAgency}`, item);
                            return checkAgency || checkFirstName || checkLastName || checkVatNumber;
                        });
                    } else {
                        data = customers.dataOff;
                    }
                    data = _.sortBy(data, ["agency"]);

                    return {
                        page: page,
                        total: data.length,
                        pages: Math.ceil(data.length / pageSize),
                        data: _.drop(data, offset).slice(0, pageSize)
                    };
                };
                offlineMethods.emptyData = () => {
                    customers.dataOff = [];
                }
                /**
                 * Prende la lista dei clienti offline
                 * @param page
                 * @param pageSize
                 * @param searchText
                 * @returns {Promise<unknown>}
                 */
                offlineMethods.get = (page, pageSize, searchText) => {
                    return new Promise((resolve, reject) => {
                        if (searchText && searchText !== "" && searchText !== null) {
                            customers.dataOff = [];
                        }
                        if (customers.dataOff.length <= 0) {
                            // non ci sono dati e quindi li prendo dallo storage la prima volta
                            localForage.getItem('customers')
                                .then((data) => {
                                    data = (data == null) ? [] : data;
                                    data.map(item => {
                                        if (item.deleted_at == null)
                                            customers.dataOff.push(item);
                                    });
                                    resolve(customers.offline.buildOfflineData(page, pageSize, searchText))
                                })
                                .catch(() => {
                                    resolve([]);
                                })
                        } else {
                            resolve(customers.offline.buildOfflineData(page, pageSize, searchText))
                        }
                    });
                };
                /**
                 * Inserisce un cliente al database
                 * @param customer
                 * @returns {Promise<unknown>}
                 */
                offlineMethods.add = (customer) => {
                    return new Promise((resolve, reject) => {
                        let customersData = [];
                        localForage.getItem('customers')
                            .then((data) => {
                                data = (data == null) ? [] : data;
                                data.map(item => {
                                    customersData.push(item);
                                });
                                customersData.push(customer);
                                localForage.setItem('customers', customersData, (err, value) => {
                                    if (err == null) {
                                        resolve(customer.id);
                                    }
                                    reject(err);
                                });
                            })
                            .catch((err) => {
                                reject(err)
                            })
                    });
                }
                customers.offline = offlineMethods;
            }
        });
        Vue.prototype.api.customers = customers;
    }
}
